import { ChevronLeft, ChevronRight } from "lucide-react";

const AIToggleButton = ({ open, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="
        fixed
        top-1/2
        -translate-y-1/2
        z-50
        bg-cyan-600
        hover:bg-cyan-700
        text-white
        rounded-l-xl
        shadow-xl
        transition-all
        duration-300
        flex
        flex-col
        items-center
        justify-center
        px-2
        py-4
        gap-2
      "
      style={{
        right: open ? "360px" : "0px",
      }}
    >
      {open ? (
        <ChevronRight size={18} />
      ) : (
        <ChevronLeft size={18} />
      )}

      <span
        className="
          text-[11px]
          font-semibold
          tracking-wider
          uppercase
          select-none
        "
        style={{
          writingMode: "vertical-rl",
          textOrientation: "mixed",
        }}
      >
        AI Agent
      </span>
    </button>
  );
};

export default AIToggleButton;